var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"preview-center",attrs:{"no-gutters":""}},[_c('b-col',[_c('b-form-checkbox',{attrs:{"size":"lg"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }